import { KeyColors } from "@/theme/colors";
import styled from "styled-components";
import { buttonBaseStyles, onClickWithAnalytics } from "./common";
import { ButtonCommonProps } from "./types";

/**
 * Types
 */

type ButtonLinkProps = ButtonCommonProps & {
  $backgroundColor?: KeyColors;
  $borderRadius?: number;
};

/**
 * Styled Components
 */

const StyledButtonLink = styled.button<Omit<ButtonLinkProps, "text">>`
  ${
    // @ts-expect-error check this error with styled-components
    buttonBaseStyles
  };
  ${({ $backgroundColor = "white", theme, $borderRadius }) => `
    background-color: ${theme.Colors[$backgroundColor]};
    border-radius: ${$borderRadius ? `${$borderRadius}px` : "24px"};

    :hover {
      background-color: ${theme.Colors.gray200};
      color: ${theme.Colors.gray400};
    }

    :disabled {
      background-color: ${theme.Colors.white};
      color: ${theme.Colors.gray300};
    }
`}
`;

/**
 * ButtonLink Component
 */

export const ButtonLink = ({
  disabled = false,
  onClick,
  testId,
  text,
  type = "button",
  $borderRadius,
  analyticsContext,
  ...rest
}: ButtonLinkProps) => (
  <StyledButtonLink
    disabled={disabled}
    onClick={() =>
      onClickWithAnalytics(onClick, {
        button_text: text,
        button_type: type,
        ...analyticsContext ?? {},
      })
    }
    data-testid={testId}
    type={type}
    $borderRadius={$borderRadius}
    {...rest}
  >
    {text}
  </StyledButtonLink>
);
